import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import ProfileExperienceVO, { EtcExperiencesVO } from '@domain/vo/profile/ProfileExperienceVO';
import { CountryCodeDto } from '@domain/rs/code/CountryCodeRs';
import { ExperienceType, Experience, ExperienceNameMap } from '@domain/constant/profile/ExperienceType';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import DateFormat from '@utils/date/format';

export default class ProfileExperienceFormVO {
  activities: ExperienceFromVO[];
  foreignExperiences: ExperienceFromVO[];
  experiences: EtcExperiencesVO[];
  sourcePage?: SourcePage;

  constructor(vo: ProfileExperienceVO & DataLogRq) {
    this.activities = vo.activitiesAndForeignExperiences
      .filter((item) => item.tag !== Experience.OVERSEAS)
      .map((item) => new ExperienceFromVO(item));
    this.foreignExperiences = vo.activitiesAndForeignExperiences
      .filter((item) => item.tag === Experience.OVERSEAS)
      .map((item) => new ExperienceFromVO(item));
    this.experiences = vo.experiences;
    this.sourcePage = vo.sourcePage;

    //데이터 없을 경우 초기값 셋팅함
    this.initValue();
  }

  initValue() {
    if (this.activities.length === 0) {
      this.activities = [
        new ExperienceFromVO({
          tag: null,
          code: null,
          title: '',
          startDate: '',
          endDate: '',
          description: '',
        }),
      ];
    }

    if (this.foreignExperiences.length === 0) {
      this.foreignExperiences = [
        new ExperienceFromVO({
          tag: null,
          code: null,
          title: '',
          startDate: '',
          endDate: '',
          description: '',
        }),
      ];
    }

    if (this.experiences.length === 0) {
      this.experiences = [
        new EtcExperiencesVO({
          description: '',
        }),
      ];
    }
  }
}

export interface IExperienceFromVO {
  tag: ExperienceType | null;
  code: number | null; //국가 코드
  title: string;
  startDate: string;
  endDate: string;
  description: string;
}

export class ExperienceFromVO {
  tag: ReactSelectOption | null;
  code: CountryCodeDto | null; //국가 코드
  title: string;
  startDate: string;
  endDate: string;
  description: string;

  constructor(vo: IExperienceFromVO) {
    this.tag = vo.tag ? { value: vo.tag, label: ExperienceNameMap[vo.tag] } : null;
    this.code = vo.code ? { code: vo.code, name: vo.title } : null;
    this.startDate = this.getDateFormat(vo.startDate);
    this.endDate = this.getDateFormat(vo.endDate);
    this.title = vo.title;
    this.description = vo.description;
  }

  getDateFormat(data: string | null) {
    return DateFormat.getDateFormatString(data, 'yyyy-MM') ?? '';
  }
}
